import ROUTES from 'constants/routes';

const namespaceRoots = [
	ROUTES.HOME,
	ROUTES.APPLICATION,
	ROUTES.LOGS_BASE,
	ROUTES.TRACES_EXPLORER,
	ROUTES.TRACES_SAVE_VIEWS,
	ROUTES.TRACES_FUNNELS,
	ROUTES.TRACE_BASE,
	ROUTES.ALL_DASHBOARD,
	ROUTES.METRICS_EXPLORER_BASE,
	ROUTES.INFRASTRUCTURE_MONITORING_BASE,
	ROUTES.LIST_ALL_ALERT,
	ROUTES.ALL_ERROR,
	ROUTES.ERROR_DETAIL,
	ROUTES.SERVICE_MAP,
	ROUTES.MESSAGING_QUEUES_BASE,
	ROUTES.API_MONITORING_BASE,
];

export const isLogRouteAllowed = (
	path: string,
	restricted: boolean,
	mode?: 'namespace',
): boolean => {
	if (!restricted) {
		return true;
	}
	if (mode !== 'namespace') {
		return path === ROUTES.LOGS;
	}
	if (
		[ROUTES.LOGS_PIPELINES, ROUTES.ALERTS_NEW, ROUTES.EDIT_ALERTS].some(
			(route) => path === route,
		)
	) {
		return false;
	}
	return namespaceRoots.some(
		(root) => path === root || path.startsWith(`${root}/`),
	);
};

export const isLogNavigationItem = (
	key: string | number | undefined,
	restricted: boolean,
	mode?: 'namespace',
): boolean =>
	!restricted ||
	(mode === 'namespace'
		? typeof key === 'string' && isLogRouteAllowed(key, true, mode)
		: key === ROUTES.LOGS);

export const isLogAccountMenuItem = (
	key: string | number | undefined,
	restricted: boolean,
): boolean => !restricted || key === 'label' || key === 'logout';
